import {cancelControlledInputUpdateSuccess, ControlledInputsActionsUnion, getControlledInputsSuccess, updateControlledInputSuccess, wsControlledInputUpdateSuccess} from '../actions/controlled-inputs.actions';
import {ControlledInput} from '../../../units/models/controlled-input';
import {LocalState} from '../../../units/models/local-state';
import { InputState } from '../../../units/models/input-state';


export interface State {
  controlledInputs: {[key: number]: ControlledInput[] } | null;
}

export const initialState: State = {
  controlledInputs: {},
};

export function reducer(
  state = initialState,
  action: ControlledInputsActionsUnion
): State {
  switch (action.type) {
    case getControlledInputsSuccess.type: {
      const newControlledInputs = {...state.controlledInputs};
      action.controlledInputs.forEach(x => {
        x.inputs.forEach(input => {
          if (input.inputState === InputState.Current) {
            input.localState = input.currentState ? LocalState.ACTIVE : LocalState.INACTIVE;
          } else {
            input.localState = LocalState.PENDING;
          }
        });
        newControlledInputs[x.unitId] = x.inputs;
      });

      return {
        ...state,
        controlledInputs: newControlledInputs
      };
    }
    case wsControlledInputUpdateSuccess.type: {
      const newControlledInputs = {...state.controlledInputs};
      action.data.forEach(x => {
        x.inputs.forEach((input: ControlledInput) => {
          if (!newControlledInputs[x.unitId]) { return -1; }
          const indexToUpdate = newControlledInputs[x.unitId].findIndex(i => i.inputName === input.inputName);
          if (indexToUpdate > -1) {
            if (input.inputState === InputState.Current) {
              input.localState = input.currentState ? LocalState.ACTIVE : LocalState.INACTIVE;
            } else {
              input.localState = LocalState.PENDING;
            }
            newControlledInputs[x.unitId][indexToUpdate] = input;
          }
        });
      });

      return {
        ...state,
        controlledInputs: newControlledInputs
      };
    }
    case updateControlledInputSuccess.type:
    case cancelControlledInputUpdateSuccess.type: {
      const newControlledInputs = {...state.controlledInputs};
      if (newControlledInputs[action.data.unitId]) {
        const input: ControlledInput = newControlledInputs[action.data.unitId].find(x => x.inputName === action.data.inputName);
        input.localState = LocalState.PENDING;
        input.inputState = action.data.inputState;
        input.destinationState = action.data.destinationState;
      }

      return {
        ...state,
        controlledInputs: newControlledInputs
      };
    }
    default: {
      return state;
    }
  }
}
export const getControlledInputs = (state: State, unitId: number) => state.controlledInputs[unitId];
export const getAllControlledInputs = (state: State) => state.controlledInputs;
